import api from "./Api";

class CartaCorrecaoNFeService {
  GetCartaCorrecaoNFe(payload) {
    return api.get("/v1/CartaCorrecaoNFe/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCartaCorrecaoNFe(payload) {
    return api.post("/v1/CartaCorrecaoNFe/", payload).then((response) => {
      return response.data;
    });
  }

  PutCartaCorrecaoNFe(payload) {
    return api.put("/v1/CartaCorrecaoNFe/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCartaCorrecaoNFe(payload) {
    return api.delete("/v1/CartaCorrecaoNFe/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCartaCorrecaoNFeOData(payload) {
    return api.get("/OData/CartaCorrecaoNFe" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CartaCorrecaoNFeService();
